module.exports = __webpack_public_path__ + "static/media/letter_4@3x.0117e43c.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_4@3x.png
// module id = 588
// module chunks = 0